import React from 'react'
import { inject, observer } from 'mobx-react'
import { FieldTypeOptions } from '../../../RightSideBar/information/FieldTypeSelect'
import CurrencySelect from '../../../common/CurrencySelect'

const AddFieldForm = ({ manageModalStore }) => {
  const fieldsStore = manageModalStore.fields
  const { saving, newType, newName, newCurrency, selectedType } = fieldsStore

  const handleSubmit = (event) => {
    event.preventDefault()
    fieldsStore.addField()
  }

  return (
    <>
      <div className='manage-modal__field-types' role='group' aria-label='Field type'>
        {FieldTypeOptions.map(option => (
          <button
            key={option.type}
            type='button'
            className={option.type === newType ? 'active' : ''}
            onClick={() => fieldsStore.setNewType(option.type)}
          >
            {option.icon}
            <span>{option.label}</span>
          </button>
        ))}
      </div>
      <form className='manage-modal__tag-form' onSubmit={handleSubmit}>
        <div className='manage-modal__tag-input-wrap'>
          <span className='manage-modal__field-icon' aria-hidden='true'>{selectedType.icon}</span>
          {newType === 'currency' && (
            <div className='manage-modal__currency-select'>
              <CurrencySelect
                currency={newCurrency}
                onChange={option => fieldsStore.setNewCurrency(option.value)}
              />
            </div>
          )}
          <input
            className='glass'
            type='text'
            value={newName}
            onChange={event => fieldsStore.setNewName(event.target.value)}
            placeholder={`New ${selectedType.label.toLowerCase()} field`}
            aria-label='New field name'
            maxLength={100}
          />
        </div>
        <button type='submit' disabled={saving || !newName.trim()}>Add field</button>
      </form>
    </>
  )
}

export default inject('manageModalStore')(observer(AddFieldForm))
